import React from 'react';
import { useTranslation, Translation } from 'react-i18next';
import PropTypes from 'prop-types';
import set from 'lodash/set';
import { reduxForm, FieldArray } from 'redux-form';
import {
  FormUi,
  Header,
  Dimmer,
  Loader,
  Segment,
  Flex,
  Button,
} from 'nallian-shared-ui/lib/components';
import HostsFields from './HostsFields';

const validate = values => {
  const errors = {};
  const primaryHosts = (values?.hosts || []).filter(h => h.isPrimary)?.length;

  if (primaryHosts !== 1) {
    (values?.hosts || []).forEach((h, hostIndex) =>
      set(
        errors,
        `hosts[${hostIndex}].isPrimary`,
        <Translation>
          {t => t(primaryHosts > 1 ? 'onlyOnePrimaryHost' : 'minOnePrimaryHost')}
        </Translation>
      )
    );
  }

  (values?.hosts || []).forEach((h, hostIndex) => {
    if (!h.host)
      set(
        errors,
        `hosts[${hostIndex}].host`,
        <Translation>{t => t('pleaseEnterAHost')}</Translation>
      );
  });

  return errors;
};

const HostsForm = ({ handleSubmit, onSubmitForm, loading, submitting }) => {
  const { t } = useTranslation();

  return (
    <FormUi fluid onSubmit={handleSubmit(onSubmitForm)}>
      <Segment basic>
        <Dimmer active={loading} inverted>
          <Loader />
        </Dimmer>
        {!loading && (
          <>
            <Header style={{ marginTop: '0' }} dividing>
              {t('hosts')}
            </Header>
            <FieldArray name="hosts" component={HostsFields} submitting={submitting} />
            <Flex justifyContent="flex-end" margin="1rem 0 0">
              <Button
                btnprimary
                onClick={handleSubmit(onSubmitForm)}
                disabled={submitting}
                loading={submitting}
                icon="save"
                content={t('save')}
              />
            </Flex>
          </>
        )}
      </Segment>
    </FormUi>
  );
};

HostsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

HostsForm.defaultProps = { initialValues: undefined };

export default reduxForm({
  validate,
  form: 'hosts',
  enableReinitialize: true,
})(HostsForm);
